export interface StandardResponse<T> {
  data: T
  errors: Record<string, string[]> | null
  message: string
  metadata?: {
    hasNext: boolean
    hasPrev: boolean
    limit: number
    page: number
    pages: number
    total: number
  }
  responseTime: string
  status: number
  success: boolean
  timestamp: string
}

export class ApiError extends Error {
  errors: Record<string, string[]> | null
  status: number

  constructor(message: string, status: number, errors: Record<string, string[]> | null = null) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.errors = errors
  }
}
